import { Component, inject, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Order from '../../../smoothr-web-app-core/models/Order';
import Payment from '../../../smoothr-web-app-core/models/Payment';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { PaySessionStatistics } from '../../../smoothr-web-app-core/models/PaySessionStatistics';
import { environment } from '../../../environments/environment';

export enum PaypalModalResult {
	SUCCESS = 'success',
	CANCELLED = 'cancelled',
	FAILED = 'failed',
}

export interface PaypalModalDismissData {
	result: PaypalModalResult;
	payment?: Payment;
	error?: any;
}

@Component({
	standalone: false,
	selector: 'app-paypal-modal',
	templateUrl: './paypal-modal.component.html',
	styleUrls: ['./paypal-modal.component.scss'],
})
export class PaypalModalComponent implements OnInit {
	@Input() order: Order | null = null;
	@Input() createdPayment: Payment | null = null;
	@Input() paySessionStatistics: PaySessionStatistics | null = null;

	totalPrice = 0;
	formattedTotalPrice = '';
	formattedTips = '';
	errorMessage: string | null = null;

	private repositoryService = inject(RepositoryService);
	private modalCtrl: ModalController = inject(ModalController);

	static async show(
		modalCtrl: ModalController,
		paySessionStatistics: PaySessionStatistics | null,
		order: Order,
		createdPayment: Payment
	): Promise<PaypalModalDismissData | undefined> {
		const modal = await modalCtrl.create({
			component: PaypalModalComponent,
			cssClass: 'payment-sheet-modal',
			backdropDismiss: false,
			componentProps: { order, createdPayment, paySessionStatistics },
		});
		await modal.present();
		const { data } = await modal.onDidDismiss<PaypalModalDismissData>();
		return data;
	}

	ngOnInit() {
		this.reloadPrices();
		this.openPaypal();
	}

	openPaypal() {
		this.errorMessage = null;
		if (!this.createdPayment?.paypal?.orderId) {
			this.errorMessage = 'Missing PayPal order id';
			return;
		}
		window.location.href = this.buildPaypalUrl();
	}

	reloadPrices() {
		const selectedTotalPrice = this.paySessionStatistics?.selectedTotalPrice ?? 0;
		const tipValue = this.paySessionStatistics?.tipsValue ?? 0;
		this.totalPrice = selectedTotalPrice;
		this.formattedTotalPrice = this.repositoryService.currencyFormat.format(this.totalPrice);
		this.formattedTips = this.repositoryService.currencyFormat.format(tipValue);
	}

	close() {
		this.modalCtrl.dismiss({
			result: PaypalModalResult.CANCELLED,
		} as PaypalModalDismissData);
	}

	private buildPaypalUrl(): string {
		const base = environment.paypalUrl;
		return `${base}/checkoutnow?token=${this.createdPayment?.paypal?.orderId}`;
	}
}
